import { Uppy } from '@uppy/core';
import { Dashboard } from '@uppy/react';
import { FieldProps } from 'formik';

import { client } from '../../apollo';
import { ApolloGraphQLUploads } from '../../utils';

require('@uppy/core/dist/style.css');
require('@uppy/dashboard/dist/style.css');
require('@uppy/status-bar/dist/style.css');

type Props = FieldProps & {
  onComplete: (data: any, url: any, client: any) => any;
  setUploadError?: (message: string) => any;
  uploadError?: string;
  allowedFileTypes?: string[];
  minNumberOfFiles?: number;
  maxNumberOfFiles?: number;
  maxFileSize?: number;
  dragDrop?: boolean;
  autoProceed?: boolean;
  onFileAdded?: (data: any) => void;
  setFileId?: (id: string) => void;
  client: any;
  triggerId?: string;
};

const Uploader = (props: Props) => {
  const {
    field,
    form: { setFieldValue },
    onComplete,
    onFileAdded,
    setUploadError,
    uploadError,
    setFileId,
    triggerId,
  } = props;
  const uppy = new Uppy({
    allowMultipleUploads: false,
    restrictions: {
      maxFileSize: props.maxFileSize || 10 * 1024 * 1024,
      maxNumberOfFiles: props.maxNumberOfFiles || 1,
      minNumberOfFiles: props.minNumberOfFiles || 1,
      allowedFileTypes: props.allowedFileTypes ? props.allowedFileTypes : ['image/*', 'application/pdf'],
    },
  });
  uppy.use(ApolloGraphQLUploads, {
    client,
    field,
    onComplete,
    setFieldValue,
    setUploadError,
    uploadError,
    setFileId,
  });

  uppy.on('file-added', async (file: any) => {
    if (onFileAdded) {
      onFileAdded(file);
    }
  });

  uppy.on('complete', async (result: any) => {
    if (!(result.successful && result.successful.length > 0)) {
      const response = await onComplete(false, '', client);
      setFieldValue(field.name, response.id);
      setFileId?.(response.id);
    }
  });

  return (
    // @ts-ignore
    <Dashboard
      id="upload-dashboard"
      // @ts-ignore
      inline={false}
      trigger={triggerId || '#uppy1-open'}
      uppy={uppy}
      proudlyDisplayPoweredByUppy={false}
      closeAfterFinish={false}
      disablePageScrollWhenModalOpen={false}
      animateOpenClose={true}
      showProgressDetails={true}
      note="1 file, images and pdf only"
    />
  );
};

Uploader.defaultProps = {
  autoProceed: true,
};

export default Uploader;
